/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LanguageDto model module.
 * @module model/LanguageDto
 * @version v1.0.0
 */
class LanguageDto {
    /**
     * Constructs a new <code>LanguageDto</code>.
     * @alias module:model/LanguageDto
     */
    constructor() { 
        
        LanguageDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LanguageDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LanguageDto} obj Optional instance to populate.
     * @return {module:model/LanguageDto} The populated <code>LanguageDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LanguageDto();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('seq')) {
                obj['seq'] = ApiClient.convertToType(data['seq'], 'Number');
            }
            if (data.hasOwnProperty('type')) {
                obj['type'] = ApiClient.convertToType(data['type'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} id
 */
LanguageDto.prototype['id'] = undefined;

/**
 * @member {String} name
 */
LanguageDto.prototype['name'] = undefined;

/**
 * @member {Number} seq
 */
LanguageDto.prototype['seq'] = undefined;

/**
 * @member {module:model/LanguageDto.TypeEnum} type
 */
LanguageDto.prototype['type'] = undefined;





/**
 * Allowed values for the <code>type</code> property.
 * @enum {String}
 * @readonly
 */
LanguageDto['TypeEnum'] = {

    /**
     * value: "EBOOK"
     * @const
     */
    "EBOOK": "EBOOK",

    /**
     * value: "MEDIA"
     * @const
     */
    "MEDIA": "MEDIA",

    /**
     * value: "UNKNOWN"
     * @const
     */
    "UNKNOWN": "UNKNOWN"
};



export default LanguageDto;

